import { render, staticRenderFns } from "./VectorCoordinatableObjectTransformer.vue?vue&type=template&id=76ec32c9&"
import script from "./VectorCoordinatableObjectTransformer.vue?vue&type=script&lang=ts&"
export * from "./VectorCoordinatableObjectTransformer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports